var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1855",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833328 0.833588H18.7442V18.7451H0.833328V0.833588Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1855)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09033 16.3961C5.57366 16.3961 6.0295 16.5794 6.512 16.7736C9.46783 18.1403 12.9637 17.5186 15.2412 15.2419C18.2462 12.2353 18.2462 7.34442 15.2412 4.33942C13.7862 2.88442 11.8512 2.08359 9.79116 2.08359C7.73033 2.08359 5.7945 2.88525 4.34033 4.34025C2.062 6.61692 1.442 10.1128 2.79616 13.0403C2.99116 13.5228 3.1795 13.9928 3.1795 14.4811C3.1795 14.9686 3.012 15.4594 2.8645 15.8928C2.74283 16.2494 2.55866 16.7878 2.677 16.9061C2.79283 17.0261 3.3345 16.8369 3.692 16.7144C4.12116 16.5678 4.60783 16.3994 5.09033 16.3961ZM9.77033 18.7453C8.497 18.7453 7.21533 18.4761 6.01616 17.9211C5.66283 17.7794 5.332 17.6461 5.0945 17.6461C4.82116 17.6478 4.45366 17.7744 4.09866 17.8969C3.37033 18.1469 2.46366 18.4586 1.79283 17.7903C1.1245 17.1211 1.43283 16.2169 1.68116 15.4894C1.80366 15.1311 1.9295 14.7611 1.9295 14.4811C1.9295 14.2511 1.81866 13.9578 1.64866 13.5353C0.0878286 10.1644 0.809495 6.10192 3.457 3.45609C5.147 1.76525 7.39616 0.833588 9.79033 0.833588C12.1845 0.833588 14.4345 1.76442 16.1245 3.45525C19.6178 6.94859 19.6178 12.6319 16.1245 16.1253C14.412 17.8386 12.1062 18.7453 9.77033 18.7453Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0802 10.9692C12.6202 10.9692 12.2436 10.5967 12.2436 10.1358C12.2436 9.67499 12.6127 9.30249 13.0727 9.30249H13.0802C13.5402 9.30249 13.9136 9.67499 13.9136 10.1358C13.9136 10.5967 13.5402 10.9692 13.0802 10.9692Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73957 10.9692C9.27957 10.9692 8.90291 10.5967 8.90291 10.1358C8.90291 9.67499 9.27124 9.30249 9.73208 9.30249H9.73957C10.1996 9.30249 10.5729 9.67499 10.5729 10.1358C10.5729 10.5967 10.1996 10.9692 9.73957 10.9692Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39857 10.9692C5.93857 10.9692 5.5619 10.5967 5.5619 10.1358C5.5619 9.67499 5.93107 9.30249 6.39107 9.30249H6.39857C6.85857 9.30249 7.2319 9.67499 7.2319 10.1358C7.2319 10.5967 6.85857 10.9692 6.39857 10.9692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.6b0bfb0d81cfbb8411832960152dc56c.svg";
export { ForwardRef as ReactComponent };